import { render, staticRenderFns } from "./EqifyRuleHorseHasAge.vue?vue&type=template&id=71a47f59&scoped=true"
import script from "./EqifyRuleHorseHasAge.vue?vue&type=script&lang=ts"
export * from "./EqifyRuleHorseHasAge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a47f59",
  null
  
)

export default component.exports